var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import ProfileData from "./ProfileData";
import AccountInfo from "./AccountInfo";
import Accordioncommon from "@frameworks/web/components/generic/Accordion/accordion";
import { useSelector } from "react-redux";
import di from "../di/servicelocator";
import _ from "underscore";
import { accountDetails } from "@mainDi/webDi";
import DpIds from "./DpIds";
import LinkedBanks from "./LinkedBanks";
var mainCode = (React.createElement(React.Fragment, null,
    React.createElement("span", { className: "DMSan_14_500" },
        React.createElement("span", { className: "txt_bloodRed pe-1" }, "Your account has been suspended."),
        "Please contact your RM for further information.")));
var MyDetails = function () {
    var _a, _b;
    var _c = __read(useState(), 2), acc_type = _c[0], setAccountType = _c[1];
    var _d = __read(useState(), 2), toggledAcc = _d[0], settoggledAcc = _d[1];
    var _e = __read(useState(undefined), 2), mrgSts = _e[0], setMrgSts = _e[1];
    var accData = JSON.parse(localStorage.getItem("acc_data"));
    var getprofilepicDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            payload = {
                acCode: (accData === null || accData === void 0 ? void 0 : accData.accType) === "COMEQ"
                    ? (accData === null || accData === void 0 ? void 0 : accData.prefAccTyp) == "EQ"
                        ? accData === null || accData === void 0 ? void 0 : accData.eqAccID
                        : accData === null || accData === void 0 ? void 0 : accData.coAccID
                    : (accData === null || accData === void 0 ? void 0 : accData.accType) === "EQ"
                        ? accData === null || accData === void 0 ? void 0 : accData.eqAccID
                        : accData === null || accData === void 0 ? void 0 : accData.coAccID,
            };
            di.basicProfile.getProfilePicData(payload);
            return [2 /*return*/];
        });
    }); };
    var getclientDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 1:
                    payload = (_a.accCode = (_b = (_c.sent())) === null || _b === void 0 ? void 0 : _b.accCode,
                        _a.accTyp = accData === null || accData === void 0 ? void 0 : accData.accType,
                        _a);
                    di.basicProfile.getClientDetailsData(payload);
                    return [2 /*return*/];
            }
        });
    }); };
    var AllClientDetails = useSelector(function (state) { return state.BasicProfile.ClientDetailsReducer; }
    // _.isEqual
    );
    var getallprofilepicDetails = useSelector(function (state) { return state.BasicProfile.GetProfilePicReducer; }, _.isEqual);
    var MydetailsAcc = [
        {
            title: (React.createElement("div", { className: "DMSansNormal_20_400 txt-midnight-blue" },
                "DP ",
                React.createElement("strong", null, "IDs"))),
            eventKey: "dpids",
            tabContent: (React.createElement(React.Fragment, null,
                React.createElement(DpIds, { clientdatalist: (_a = AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.data) === null || _a === void 0 ? void 0 : _a.dpid, errorAllClientDetails: AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.errorData }))),
        },
        {
            title: (React.createElement("div", { className: "DMSansNormal_20_400 txt-midnight-blue" },
                "Linked ",
                React.createElement("strong", null, "Banks"))),
            eventKey: "linkedbanks",
            tabContent: (React.createElement(React.Fragment, null,
                React.createElement(LinkedBanks, { clientdatalist: AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.data.bankslist, errorAllClientDetails: AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.errorData }))),
        },
    ];
    useEffect(function () {
        getclientDetails();
        getprofilepicDetails();
        accountDetails.getAccTyp().then(function (x) {
            setAccountType(x);
            if (x === "COMEQ") {
                accountDetails
                    .prefAccTyp()
                    .then(function (y) {
                    if (y === undefined) {
                        settoggledAcc("EQ");
                    }
                    else {
                        settoggledAcc(y);
                    }
                })
                    .catch(function (err) {
                    console.log(err);
                });
            }
        });
        accountDetails.getAccountMrgSts().then(function (x) {
            setMrgSts(x);
        });
    }, []);
    return (React.createElement("div", null,
        React.createElement(React.Fragment, null,
            React.createElement(ProfileData, { mrgSts: mrgSts, acc_type: acc_type, settoggledAcc: settoggledAcc, toggledAcc: toggledAcc, getallprofilepicDetails: getallprofilepicDetails, clientlist: (_b = AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.data) === null || _b === void 0 ? void 0 : _b.client, clientdatalist: AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.data, errorAllClientDetails: AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.errorData }),
            React.createElement(AccountInfo, { clientdatalist: AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.data, errorAllClientDetails: AllClientDetails === null || AllClientDetails === void 0 ? void 0 : AllClientDetails.errorData }),
            React.createElement(Accordioncommon, { AccordionArray: MydetailsAcc, parentClass: "common-accordian common-accordian-big-icon no-icon-bg" }))));
};
export default MyDetails;
